import { graphql, useStaticQuery } from 'gatsby';

const useHomepageData = () => {
  const { contentfulPage } = useStaticQuery(graphql`
    query {
      contentfulPage(pageId: { eq: "Homepage" }) {
        title
        seoHeader {
          metaDescription {
            metaDescription
          }
          canonicalUrl
        }
        faqSchema {
          question
          answer
        }
        topBanner {
          headline
          mainCta {
            text
            url
          }
        }
        heroSection {
          componentName
          headline
          headlineMarkdown {
            childMarkdownRemark {
              html
            }
          }
          description
          descriptionMarkdown {
            childMarkdownRemark {
              html
            }
          }
          desktopImage {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75, width: 1653)
          }
          mobileImage {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          mainCta {
            text
            url
            appearance
          }
          secondaryHeadline
          secondaryCtaList {
            text
            url
          }
          listOfContentWithImages {
            heading
            image {
              description
              gatsbyImageData(placeholder: BLURRED, quality: 75)
            }
          }
          backgroundColor
          pinImageToRight
          pinImageToBottom
          imageHeight
          textColor
        }
        sections {
          featureFlag
          componentName
          componentVariation
          slug
          title
          backgroundColor
          cardsForSection {
            callout
            cardTitle
            linkPath
            linkText
            cardImage {
              gatsbyImageData(placeholder: BLURRED, quality: 75)
            }
            cardImageMobile {
              gatsbyImageData(placeholder: BLURRED, quality: 75)
            }
            bulletPoints {
              iconAltText
              icon {
                gatsbyImageData(placeholder: BLURRED, quality: 75)
              }
              bulletText {
                childMarkdownRemark {
                  html
                }
                bulletText
              }
            }
            subHeadline {
              childMarkdownRemark {
                html
              }
            }
          }
          headline
          subHeadline
          mainCta {
            text
            url
          }
          listOfContentWithImages {
            heading
            subheading
            description {
              childMarkdownRemark {
                html
              }
              description
            }
            image {
              description
              gatsbyImageData(placeholder: BLURRED, width: 414, quality: 75)
            }
            cta {
              text
              url
            }
            callout
            number
            identifier
            featureFlag
          }
          desktopImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          mobileImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          listOfLinks {
            text
            url
          }
          carouselItems {
            id
            image {
              gatsbyImageData(placeholder: BLURRED, quality: 75)
            }
            imageLink
            text {
              childMarkdownRemark {
                html
              }
            }
          }
        }
      }
      allReviews {
        nodes {
          product_name
          product_page_id
          average_rating
          native_review_count
          question_count
          rating_histogram
          recommended_ratio
          review_count
          syndicated_review_count
        }
      }
    }
  `);

  return contentfulPage;
};
export default useHomepageData;
